import { capitalize } from 'lodash/fp'

const getMarkedText = (text: string, searchString?: string) => {
  const firstLetter = text.at(0)
  const isTextStartsCapitalized =
    firstLetter?.toUpperCase() === firstLetter && firstLetter !== '@'

  const lowerCaseText = text.toLowerCase()
  const lowerCaseSearch = searchString?.toLowerCase() || ''

  if (!lowerCaseSearch) return text

  const isSearchFromStart = lowerCaseText.startsWith(lowerCaseSearch)

  const replacedText = lowerCaseText.replace(
    lowerCaseSearch,
    `<mark>${isSearchFromStart ? capitalize(lowerCaseSearch) : searchString}</mark>`,
  )

  return isTextStartsCapitalized && isSearchFromStart
    ? replacedText
    : capitalize(replacedText)
}

export default getMarkedText
